import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../../components/footer/Footer.js";
import TopButton from "../../../components/topButton/TopButton.js";
import "./Distribution.css";
import Navigationbar from "../../../components/header/Navigationbar.jsx";
import "./Distribution.css";
import Model from "../../../containers/Model/Model.jsx";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../../contact/WhatsAppCard.jsx";

const Distribution = (props) => {
  const theme = props.theme;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);
  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
      <div className="basic-education1">
        <Model open={isModalOpen} onClose={handleCloseModal} />
        <div className="basic-education-services">
          <div className="Mutualfunds">
            {isScrollingUp && animationShown ? (
              <> 
                <div className="Mutualfunds-text">
                  <p className="Mutualfunds-text-header">Mutual Funds/IPO</p>
                  <p className="Mutualfunds-text-main">
                    Life insurance is a financial product that provides a payout to
                    beneficiaries in the event of the policyholder's death. It
                    serves as a crucial tool for financial planning and risk
                    management, offering protection and financial security to loved
                    ones.
                  </p>
                  <p className="Mutualfunds-text-main">
                    Life insurance acts as a financial safety net for dependents,
                    helping to replace the policyholder's income and cover expenses
                    such as mortgages, education, and daily living costs. Provides
                    coverage for a specific term (e.g., 10, 20, or 30 years). It
                    pays a death benefit if the policyholder passes away during the
                    term.Offers coverage for the entire lifetime of the insured and
                    includes a cash value component that grows over time.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="Mutualfunds-text">
                  <p className="Mutualfunds-text-header">Mutual Funds/IPO</p>
                  <p className="Mutualfunds-text-main">
                    Life insurance is a financial product that provides a payout to
                    beneficiaries in the event of the policyholder's death. It
                    serves as a crucial tool for financial planning and risk
                    management, offering protection and financial security to loved
                    ones.
                  </p>
                  <p className="Mutualfunds-text-main">
                    Life insurance acts as a financial safety net for dependents,
                    helping to replace the policyholder's income and cover expenses
                    such as mortgages, education, and daily living costs. Provides
                    coverage for a specific term (e.g., 10, 20, or 30 years). It
                    pays a death benefit if the policyholder passes away during the
                    term.Offers coverage for the entire lifetime of the insured and
                    includes a cash value component that grows over time.
                  </p>
                </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="Mutualfunds-card-main">
                  <div className="Mutualfunds-card">
                    <img
                      src='/assets/images/mutual-funds.jpg'
                      className="Mutualfunds-card-img-top"
                      alt="..."
                    />
                    <div className="Mutualfunds-card-body">
                      <h5
                        className="Mutualfunds-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Mutual Funds/IPO
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="Mutualfunds-card-main">
                  <div className="Mutualfunds-card">
                    <img
                      src='/assets/images/mutual-funds.jpg'
                      className="Mutualfunds-card-img-top"
                      alt="..."
                    />
                    <div className="Mutualfunds-card-body">
                      <h5
                        className="Mutualfunds-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Mutual Funds/IPO
                      </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                  </div>
                </div>
              </Zoom>
            )}
          </div>
          <div className="fixedincome">
            {isScrollingUp && animationShown ? (
              <> 
                <div className="fixedincome-card-main">
                  <div className="fixedincome-card">
                    <img
                      src='/assets/images/Fixed-Income.jpg'
                      className="fixedincome-card-img-top"
                      alt="..."
                    />
                    <div className="fixedincome-card-body">
                      <h5
                        className="fixedincome-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Fixed Income
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="fixedincome-card-main">
                  <div className="fixedincome-card">
                    <img
                      src='/assets/images/Fixed-Income.jpg'
                      className="fixedincome-card-img-top"
                      alt="..."
                    />
                    <div className="fixedincome-card-body">
                      <h5
                        className="fixedincome-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                          Fixed Income
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="fixedincome-text">
                  <p className="fixedincome-text-header">Fixed Income</p>
                  <p className="fixedincome-text-main">
                    Non-life insurance, also known as property and casualty
                    insurance, provides coverage for a wide range of risks other
                    than those related to life and health. Non-life insurance covers
                    tangible assets such as property, vehicles, and goods. It
                    protects against financial losses arising from damage,
                    destruction, or loss of these assets due to unforeseen events.
                  </p>
                  <p className="fixedincome-text-main">
                    {" "}
                    Protects against damage or loss of physical property, including
                    homes, buildings, and belongings.Covers vehicles against
                    accidents, theft, and other damages.Provides protection against
                    legal liabilities for injuries or damage to third parties.
                    Travel Insurance: Offers coverage for unexpected events during
                    travel, such as trip cancellations, medical emergencies, or lost
                    luggage.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="fixedincome-text">
                    <p className="fixedincome-text-header">Fixed Income</p>
                    <p className="fixedincome-text-main">
                      Non-life insurance, also known as property and casualty
                      insurance, provides coverage for a wide range of risks other
                      than those related to life and health. Non-life insurance covers
                      tangible assets such as property, vehicles, and goods. It
                      protects against financial losses arising from damage,
                      destruction, or loss of these assets due to unforeseen events.
                    </p>
                    <p className="fixedincome-text-main">
                      {" "}
                      Protects against damage or loss of physical property, including
                      homes, buildings, and belongings.Covers vehicles against
                      accidents, theft, and other damages.Provides protection against
                      legal liabilities for injuries or damage to third parties.
                      Travel Insurance: Offers coverage for unexpected events during
                      travel, such as trip cancellations, medical emergencies, or lost
                      luggage.
                    </p>
                </div>
              </Zoom>
            )}
          </div>
        </div>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Distribution;
